import React from "react";
import { Box, Alert } from "@mui/material";
import MuPb from "../../../../widgets/MuPb";
import { getErrorResponse } from "../../../../utils2024/utils";
import { useParams } from "react-router-dom";

import ExhibitorDetail from "./ExhibitorDetail";
import useApiEp from "../../../../hooks/useApiEp";
import BackBtn from "../../../../widgets/BackBtn";
import ProfileViewer from "../../../../widgets/ProfileViewer";

const ExhibitorProfileView = () => {
  const { id } = useParams();
  const {
    isLoading,
    isError,
    error,
    data: response,
  } = useApiEp(`/user/get-profile-view-by-id/${id}`);

  if (isLoading) {
    return <MuPb />;
  }

  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }

  return (
    <Box>
      <ProfileViewer id={response.username} />
      <BackBtn />
      <ExhibitorDetail response={response} />
    </Box>
  );
};
export default ExhibitorProfileView;
